import { axiosInstance } from "@/config/axios-wrapper";
import { V2Response } from "@/types/api";


export const getJobseekerMeetingByJobId = async (userId: string) => {
  const response = await axiosInstance.get<V2Response<any>>(`/jobseekers/${userId}/meetings`);

  return response.data.result;
};
